'use client';
import { DateTime } from 'luxon';
import React from 'react';

import ListPage from '../../../../../components/page-components/list-page/list-page';
import { createListCardArray } from '../../../../../helpers/list-page/list-page-helpers';
import useGetMobileAppWebViewHeader from '../../../../../hooks/use-get-mobile-app-web-view';
import { IMeetingPlacePageLeisurePackageOfferItem } from '@/lib/fragments/meetingPlacePageLeisurePackageOfferItem';
import { IMeetingplacePageHomeMinifiedExtendedLogo } from '@/lib/fragments/meetingPlacePageHome-minified';
import { IMeetingPlacePageLeisurePackageOfferList } from '@/lib/fragments/meetingPlacePageLeisurePackageOfferList';
import { useTenantConfig } from '@/providers/ConfigProvider';
import { GtmPageView } from '@/components/page-components/analytics/gtm-page-view';

interface MeetingPlacePageLeisurePackageOfferListProps {
  metaData: any;
  node_locale: string;
  urlSubdirectory?: string;
  lpoListData: {
    meetingPlacePageLeisurePackageOfferList: IMeetingPlacePageLeisurePackageOfferList | null;
    meetingPlacePageHomeCollection: IMeetingplacePageHomeMinifiedExtendedLogo | null;
  };
  initialPage?: number;
}

const MeetingPlacePageLeisurePackageOfferList = ({
  metaData,
  node_locale,
  urlSubdirectory,
  lpoListData,
  initialPage,
}: MeetingPlacePageLeisurePackageOfferListProps) => {
  const config = useTenantConfig();
  const prefix = config?.GATSBY_SITE_PATH_PREFIX || '';
  const page = lpoListData?.meetingPlacePageLeisurePackageOfferList;
  const homepage = lpoListData?.meetingPlacePageHomeCollection;

  let leisurePackageOfferItemPages =
    lpoListData?.meetingPlacePageLeisurePackageOfferList
      ?.leisurePackageOfferItemsCollection?.items;

  leisurePackageOfferItemPages = leisurePackageOfferItemPages
    ?.filter(Boolean)
    ?.map((offer: any) => offer as IMeetingPlacePageLeisurePackageOfferItem) //Now, we can cast
    ?.filter((offer: any) => {
      return (
        !offer?.offerValidTill ||
        DateTime.fromISO(offer?.offerValidTill).diffNow('day').days > 0
      );
    }); //Filter out those offers which offerValidTill is before today

  const leisurePackageOfferItemCardList = createListCardArray(
    leisurePackageOfferItemPages ?? [],
    undefined,
    undefined,
    urlSubdirectory,
    node_locale,
    prefix,
  );

  const isWebView = useGetMobileAppWebViewHeader();

  return (
    <>
      {page && (
        <>
          {/* ✅ GTM PAGE VIEW */}
          <GtmPageView
            homepage={homepage}
            language={node_locale}
            pageTitle={page?.name ?? ''}
          />

          <ListPage
            cardList={leisurePackageOfferItemCardList}
            pageName={page?.name}
            pageSlug={page?.slug}
            node_locale={node_locale}
            breadcrumbs={[page?.name]}
            homeText={homepage?.breadcrumbHomeText ?? ''}
            tileColClass="grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
            listType="leisure_package_offer"
            isWebView={isWebView}
            initialPage={initialPage ?? 1}
          />
        </>
      )}
    </>
  );
};

export default MeetingPlacePageLeisurePackageOfferList;
